import React from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import * as actions from "../../../../static/assets/js/actions/actions";
import IconHero from "../../../../static/assets/js/components/nounproject-icon-hero.jsx";
import {
    NO_PREMIUM_FEATURES,
    YES_DO_UPSELL
} from "../../../../static/assets/js/reducers/download";
// not using absolute paths because Mocha complains

class DownloadFlowModal extends React.Component {
    constructor(props) {
        super(props);
        this.onConfirm = this.onConfirm.bind(this);
        this.onDismiss = this.onDismiss.bind(this);
    }

    onConfirm(evt) {
        if (this.props.onCloseAction) {
            this.props.onCloseAction();
        }
        this.props.dismissModal();
    }

    onDismiss(evt) {
        if (this.props.onCloseAction) {
            this.props.onCloseAction();
        }
        this.props.dismissModal();
    }

    render() {
        let classes = classnames("download-flow-modal");
        return (
            <div className={classes}>
                <IconHero
                    inModal
                    icon={this.props.icon}
                    refech={this.props.refetchIcon}
                    onCloseAction={this.onDismiss}
                />
            </div>
        );
    }
}

export default DownloadFlowModal;
// being used in static/assets/js/constants/modalTypes.js
